import { BarContainer, Bar, LegendItem, StyledBullet, BarChartLegend } from './Styled';

export const Bullet = ({ color }) => (
  <StyledBullet
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill={color} />
  </StyledBullet>
);

export const ProgressBar = ({ data }) => {
  const hasLegend = data.length > 1 && !!data[0].name;
  return (
    <div>
      <BarContainer>
        {data.map(({ color, percentage }) => (
          <Bar key={color} color={color} percentage={percentage} />
        ))}
      </BarContainer>
      {hasLegend && (
        <BarChartLegend>
          {data.map(({ color, name }) => (
            <LegendItem key={name}>
              <Bullet color={color} />
              {name}
            </LegendItem>
          ))}
        </BarChartLegend>
      )}
    </div>
  );
};
